import AdvertisingSlot from '@src/components/Ads/AdvertisingSlot';
import useAd from '@src/store/domain/useAd';
import { Fragment, memo } from 'react';

interface BottomStickyAdProps {
    tokenName: string;
    postId?: string;
}

const BottomStickyAd: React.FC<BottomStickyAdProps> = props => {
    const { postId, tokenName } = props;

    const location = 'btm_sticky';

    const { ad, sizeStyle } = useAd(location, tokenName);
    if (!ad) return <div />;

    return (
        <Fragment>
            <AdvertisingSlot divIdSufix={postId} className="fixed bottom-0 z-10 -translate-x-1/2 left-1/2" location={location} tokenName={tokenName} />
            {/* Save space for the ad */}
            <div style={sizeStyle} />
        </Fragment>
    );
};

export default memo(BottomStickyAd);
